module.exports = __webpack_public_path__ + "static/img/left.cfbde769.png";